import { Input, Label } from '@up2stay/up2promo-ui';

export type ProductFormUsernameFieldProps = {
  id: string;
  value: string;
  onChange: (v: string) => void;
  label?: string;
  placeholder?: string;
};

export function ProductFormUsernameField({
  id,
  value,
  onChange,
  label,
  placeholder,
}: ProductFormUsernameFieldProps) {
  return (
    <div className="space-y-0.5 min-w-0 w-full">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        autoComplete="username"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}
